"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var table = {};
table["RPBALANCED"] = 0.9;
table["RPGROWTH"] = 0.9;
table["RPHIGHGROWTH"] = 0.9;
table["RPMODERATE"] = 0.9;
exports.default = table;
//# sourceMappingURL=NormalFeeTable.js.map